import { api } from "./api";

export interface SaveConsentNewRequest {
    TenantId: number;
    Code: string;
    OutletName: string;
    Address: string;
    PhoneNumber: string;
    City: string;
    Province: string;
    PostalCode: string;
    MokaOutletID: string;
    AccessToken: string;
    RefreshToken: string;
    PasswordAPI: string;
    CreatedAt: number;
    ExpiresIn: number;
}

export interface SaveConsentNewResponse {
    Code: number;
    Message: string;
}

export const saveConsentNew = async (
    payload: SaveConsentNewRequest
): Promise<SaveConsentNewResponse | undefined> => {
    try {
        const url = `/moka/v1/saveconsentnew`;
        const response = await api.post(url, payload);
        if (response.status === 200) return response.data;
    } catch (error) {
        console.log(error);
    }
};

export const disconnectMokaOutlet = async (outletId: number) => {
    try 
    {
        const url = `/moka/v1/deletemokaoutlet`;
        const response = await api.post(url, { MokaOutletId: outletId });
        if (response.status === 200) {
            return response.data;
        }
    }
    catch (error){
        console.log(error);
    }
}

export interface GetTransactionRequest {
    TenantId: number;
    Since: string;
    Until: string;
}

export interface GetTransactionResponse {
    data: {
        payments: any;
        next_url: string | null;
        completed: boolean;
    };
    meta: {
        code: number;
        errors: any;
    };
}

export const getTransaction = async (payload: GetTransactionRequest): Promise<GetTransactionResponse | undefined> => {
    try {
        const url = `/moka/v1/gettransaction`;
        const response = await api.post(url, payload);
        if (response.status === 200) return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}